// StudentSignupPre.container: student signup entry — email or OAuth; OAuth via thpe-auth social-redirect.
// Mistake: coupled school-id fetch and invite UI here; invite still works via school-id kept on register URLs only.
// Mistake: LINE signup used generic social-redirect; route LINE through LIFF URL/ID from env to keep in-app auth flow.
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getLanguageValue } from "locales/i18n";
import { PAGE_TYPE } from "enums";
import { executeAppleOAuth } from "helpers/AppleOauth.helper";
import { isAppWebViewContextQuick } from "helpers/InApp.helper";
import { requestNativeSocialLogin } from "helpers/SocialBridge.helper";
import StudentSignupPreComponent from "./StudentSignupPre.component";

const StudentSignupPreContainer = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const authBase = (process.env.REACT_APP_AUTH_URL || "").replace(/\/+$/, "");
    const goOAuth = async (provider: "google" | "kakao" | "line" | "apple") => {
        if (provider === "apple") {
            await executeAppleOAuth({
                flow: "signup",
                authBase,
                locationSearch: location.search || "",
                onNativeBridgeError: (message: string) => {
                    alert(message || getLanguageValue(PAGE_TYPE.COMMON, "studentSignupPre.oauthNotReady"));
                },
            });
            return;
        }
        const result = await requestNativeSocialLogin(provider, "signup");
        if (result) {
            if (result && !result.ok) {
                if (result.errorCode === "CANCELLED") {
                    return;
                }
                alert(result.message || getLanguageValue(PAGE_TYPE.COMMON, "studentSignupPre.oauthNotReady"));
            }
            return;
        }
        if (await isAppWebViewContextQuick()) {
            return;
        }

        if (provider === "line") {
            navigate({ pathname: "/line/liff/callback", search: `${location.search || ""}${location.search ? "&" : "?"}flow=signup` }, { replace: true });
            return;
        }
        if (!authBase) {
            alert(getLanguageValue(PAGE_TYPE.COMMON, "studentSignupPre.oauthNotReady"));
            return;
        }
        const q = location.search || "";
        window.location.href = `${authBase}/auth/social-redirect/${provider}${q}`;
    };

    const goEmailSignup = () => {
        navigate(`/signup/student/register/account${location.search}`, { state: {} });
    };

    return (
        <StudentSignupPreComponent
            onEmailSignup={goEmailSignup}
            onGoogleSignup={() => {
                void goOAuth("google");
            }}
            onLineSignup={() => {
                void goOAuth("line");
            }}
            onKakaoSignup={() => {
                void goOAuth("kakao");
            }}
            onAppleSignup={() => {
                void goOAuth("apple");
            }}
            backUrl="/signup"
        />
    );
};

export default StudentSignupPreContainer;
